import MenuActionTypes from './menu-types';

const INITIAL_STATE = {
  estados: {},
  idDetalle: 0,
  idEstado: 0,
  idDistrito: 0
};

const menuReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {  
    case MenuActionTypes.UPDATE_LISTA_ESTADOS:
      return {
        ...state,
        estados: action.payload
      };
    case MenuActionTypes.UPDATE_ESTADO:
      return {
        ...state,
        idEstado: action.payload
      };

    case MenuActionTypes.UPDATE_LISTA_PROCESOS:
      return {
        ...state,
        estados:{
          ...state.estados,
          [action.payload.idEstado]: {
            ...state.estados[action.payload.idEstado],
            procesos: action.payload.procesos
          }
        }
      };
    case MenuActionTypes.UPDATE_DETALLE:
      return {
        ...state,
        idDetalle: action.payload,
      };
    case MenuActionTypes.UPDATE_LISTA_DISTRITOS:
      return {
        ...state,
        estados:{
          ...state.estados,
          [action.payload.idEstado]: {
            ...state.estados[action.payload.idEstado],
            procesos: {
              ...state.estados[action.payload.idEstado].procesos,
              [action.payload.idDetalle]:{
                ...state.estados[action.payload.idEstado].procesos[action.payload.idDetalle],
                distritos: action.payload.distritos
              } 
            }
          }
        }
      };
    case MenuActionTypes.UPDATE_DISTRITO:
      return {
        ...state,
        idDistrito : action.payload
      };
    case MenuActionTypes.UPDATE_RUTA_PUBLICADOR:
      return {
        ...state,
        estados:{
          ...state.estados,
          [action.payload.idEstado]: {
            ...state.estados[action.payload.idEstado],
            procesos: {
              ...state.estados[action.payload.idEstado].procesos,
              [action.payload.idDetalle]:{
                ...state.estados[action.payload.idEstado].procesos[action.payload.idDetalle],
                rutaPublicador: action.payload.rutaPublicador
              } 
            }
          }
        }
      };

    default:
      return state;
  }
};

export default menuReducer;